// src/components/ProtectedRoute.tsx
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: JSX.Element;
    isLoggedIn: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, isLoggedIn }) => {
    return isLoggedIn ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
